import Footer from "components/Footer/Footer";
import Navbar from "components/Navbar/Navbar";
import React, { Suspense } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";

const PublicLayout = ({ children }) => {
  const location = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <React.Fragment>
      <div className="bg-paper-main">
        <Navbar />
        <Suspense
          fallback={
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
              className="flex justify-center items-center w-full h-screen"
            >
              <motion.div
                animate={{
                  rotate: 360,
                  transition: { repeat: Infinity, duration: 2 },
                }}
                className="w-16 h-16 border-4 border-t-4 border-gray-300 border-t-transparent rounded-full"
              />
            </motion.div>
          }
        >
          {children}
          <Footer />
        </Suspense>
      </div>
    </React.Fragment>
  );
};

export default PublicLayout;
